import styled from "styled-components";
import { css } from "styled-components";

export const Section = styled.div`
	display: flex;
	padding: 0 60px;
	justify-content: center;

	@media (max-width: 1100px) {
		padding: 0px 30px;
	}
`;

export const SectionLarge = styled.div`
	display: flex;
	max-width: 1800px;
	width: 100%;
`;

export const SectionMedium = styled.div`
	display: flex;
	max-width: 1300px;
`;

export const SectionSmall = styled.div`
	display: flex;
	max-width: 900px;
`;

export const Article = styled.div`
	padding: 25px 50px 50px 50px;

	@media (max-width: 600px) {
		padding: 25px;
	}
`;

export const Text = styled.span`
	color: ${({ color }) => color ?? "#000"};

	${({ size }) =>
		size &&
		css`
			font-size: ${({ size }) => `${size}px !important`};
		`}

	&:hover {
		${({ hover }) => hover}
	}

	${({ header }) =>
		header &&
		css`
			font-size: 44px;
			line-height: 44px;
			font-weight: 700;
			font-family: Helvetica Neue, Helvetica, Arial, sans-serif;

			@media (max-width: 768px) {
				font-size: 30px;
				line-height: 30px;
			}
		`}

	${({ midExtreme }) =>
		midExtreme &&
		css`
			font-size: 50px;
			line-height: 50px;
			font-weight: 900;
			font-family: Helvetica Neue, Helvetica, Arial, sans-serif;

			@media (max-width: 768px) {
				font-size: 30px;
				line-height: 30px;
			}
		`}

${({ extreme }) =>
		extreme &&
		css`
			font-size: 70px;
			line-height: 70px;
			font-weight: 900;
			font-family: Helvetica Neue, Helvetica, Arial, sans-serif;

			@media (max-width: 768px) {
				font-size: 44px;
				line-height: 44px;
			}
		`}

	${({ lede }) =>
		lede &&
		css`
			font-size: 24px;
			line-height: 1.35;
			font-weight: 500;
			font-family: Helvetica Neue, Helvetica, Arial, sans-serif;

			@media (max-width: 768px) {
				font-size: 18px;
			}
		`}

	${({ body }) =>
		body &&
		css`
			font-size: 20px;
			line-height: 1.45;
			font-weight: 400;

			@media (max-width: 768px) {
				font-size: 17px;
			}
		`}
`;

export const MobilePreview = styled.div`
	height: min-content;
	top: 120px;
	padding: 10%;
	display: flex;

	@media (min-width: 768px) {
		position: sticky;
	}

	@media (max-width: 768px) {
		padding: 5% 10%;
		max-width: 400px;
	}
`;

export const RetractableSection = styled.div``;

export const AppStoreButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 30px 75px;
	height: 50px;
	z-index: 1;

	@media (min-width: 768px) {
		position: sticky;
		top: 60px;
	}

	@media (max-width: 768px) {
		position: relative;
		top: 0;
		justify-content: center;
		padding: 30px;
	}
`;
